import type { IconSvgObject } from './types';

const SevenSquareIcon: IconSvgObject = [
  ["path", { d: "M9 7H14.584C14.8138 7 15 7.18625 15 7.41599C15 7.47144 14.9889 7.52632 14.9674 7.57742L11 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.5 21.5L19.5 21.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SevenSquareIcon;
